import React from "react";

const Loader = () => {
  return (
    <div className="loading-page">
      <div className="loading-logo" />
    </div>
  );
};

export default Loader;
